//**auto-generated don't edit this code**//
export enum Color {
	None,
	Blue,
	Yellow,
	Red,
	Purple,
	Green,
	Grey,
	Orange,
	Indigo,
}